export default __webpack_public_path__ + "static/media/programs.fcfc96b9.png";